export default __webpack_public_path__ + "static/media/smtverification.24b295de.png";